'use strict';

module Patersons {

    export interface PrivateWealthScope extends ng.IScope {
        morningMarket: Feed;
        //weeklyMarketWrap: Feed;
        modelPortfolioUpdate: Feed;
        modelPortfolio: Feed;
        sectorStrategy: Feed;
        australianInvestor: Feed;
        fixedInterestSecurities: Feed;
        momentumMonitor: Feed;
        qualityInvesting: Feed;
        marketStrategy: Feed;
        highYieldStocks: Feed;
        
        otherFeatured1: Feed;
        otherFeatured2: Feed;
        otherFeatured3: Feed;
        feedList: Feed[];

        events: Patersons.PrivateWealthCtrl;
    }

    export class PrivateWealthCtrl extends ResearchBaseCtrl {

        scope: Patersons.PrivateWealthScope;
        location: ng.ILocationService;
        window: ng.IWindowService;
        stateParams: angular.ui.IStateProvider;
        state: angular.ui.IStateService;
        http: ng.IHttpService;
        researchFeedService: ResearchFeedService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.researchFeedService = researchFeedService;

            this.scope.events = this;

            this.load();
        }

        load() {
            this.researchFeedService.getFeaturedPrivateWealthResearch()
                .then(result => {
                    let feedItems: Feed[] = result;
                    this.scope.modelPortfolioUpdate = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Model Portfolio Update');
                    this.scope.modelPortfolio = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Model Portfolio');
                    this.scope.sectorStrategy = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Sector Strategy');
                    this.scope.australianInvestor = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Australian Investor');
                    
                    this.scope.momentumMonitor = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Momentum Monitor');
                    this.scope.qualityInvesting = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Investment Strategy');
                    this.scope.highYieldStocks = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'High Yield Stocks');
                    this.scope.fixedInterestSecurities = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Fixed Interest Securities');
                    this.scope.marketStrategy = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Market Strategy');
                    
                }, (error) => { // error handling
                    console.log('Data is not availabe');
                });


            this.researchFeedService.getTop3PrivateWealthResearch()
                .then(result => {
                    let feedItems: Feed[] = result;

                    if (feedItems === null || feedItems === undefined) {
                        return;
                    }

                    this.scope.otherFeatured1 = feedItems.length >= 1 ? feedItems[0] : null;
                    this.scope.otherFeatured2 = feedItems.length >= 2 ? feedItems[1] : null;
                    this.scope.otherFeatured3 = feedItems.length >= 3 ? feedItems[2] : null;
                }, (error) => { // error handling
                    console.log('Data is not availabe');
                });

            this.researchFeedService.getAllPrivateWealthResearch()
                .then(result => {
                    this.scope.feedList = result;
                }, (error) => { // error handling
                    console.log('Data is not availabe');
                });
        }
    }
}
